export default __webpack_public_path__ + "static/media/ford.46b1ece8.jpg";